import styled from 'styled-components'

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 0.1fr auto;
  grid-column-gap: 32px;
`

export const Header = styled.header`
  display: grid;
  grid-template-columns: 0.1fr auto;
  padding-bottom: 20px;

  @media (max-width: 1280px) {
    grid-template-columns: auto;
  }
`

export const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  button {
    height: 48px;
    max-width: 235px;
    border-radius: 6px;
  }

  @media (max-width: 1024px) {
    button {
      flex: 1;
      font-size: 0.875rem;
    }
  }
`

export const SidePanel = styled.section``

export const Content = styled.section`
  overflow-x: auto;
`
